/**
 * @file 主要做一些全局初始化的工作
 */
import { Web3LeaveNotification } from '@web3fe/infra';
import { ToastContainer } from '@bfe/moly';
import { Layout } from '@web3/base-components';
import '@web3/base-css';
// 如果项目中没用windi可以删掉
import 'windi.css';
import '@/assets/css/index.css';

export default function MyApp({ Component, pageProps }) {
  return (
    <Layout
      {...pageProps}
      // 如果需要支持响应式布局，则使用改属性，会动态修改html上的font，否则可以删掉
      remConfig={{
        breakpointWidth: 768,
        designWidth: 375,
      }}
    >
      <ToastContainer />
      <Web3LeaveNotification bizType="point" />
      <Component {...pageProps} />
    </Layout>
  );
}
